export default __webpack_public_path__ + "static/media/6a.d96460ef.png";